import { render } from "./internal-consumption-modal.vue?vue&type=template&id=36b420f7"
import script from "./internal-consumption-modal.vue?vue&type=script&lang=js"
export * from "./internal-consumption-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__